import BankAccountList from './BankAccountList';

export default BankAccountList;
